module.exports = __webpack_public_path__ + "static/media/Event format illustration_v04.5e3c80c5.gif";